package com.kinoshazam

import com.kinoshazam.data.GlobalStateRepository
import com.kinoshazam.uiKit.theme.uiKitLocalizationState
import org.koin.mp.KoinPlatform.getKoin

/** Apply persisted in-app language before first Compose frame (e.g. splash). */
fun applyStoredAppLanguage() {
    val language = getKoin().get<GlobalStateRepository>().appLanguage.value
    changeLanguage(language)
    uiKitLocalizationState.value = language
}
